import '../wwwroot/js/calendar-header.js';
import '../wwwroot/css/calendar-header.css';
// Hosts supply their existing libraries; the same controls also enhance fetched panels.
export function registerPresenceControls(TomSelect, flatpickr, Spanish) {
    window.TomSelect = TomSelect;
    window.dispatchEvent(new CustomEvent('profint:controls-ready'));
    window.profintPresenceControls = root => {
        root.querySelectorAll('select').forEach(select => {
            if (select.tomselect) return;
            new TomSelect(select, { maxOptions: null, create: false, allowEmptyOption: true, openOnFocus: false });
        });
        root.querySelectorAll('[name="endsAtLocal"]').forEach(input => {
            if (input._flatpickr) return;
            flatpickr(input, { locale: Spanish, enableTime: true, time_24hr: true, disableMobile: true,
                dateFormat: 'Y-m-d\\TH:i', altInput: true, altFormat: 'd/m/Y H:i', allowInput: true,
                appendTo: input.parentElement,
                onReady: (_dates, _text, instance) => window.ProfintCalendarHeader.install(instance) });
            input._flatpickr.altInput.required = false;
        });
    };
    document.dispatchEvent(new Event('profint:presence-controls-ready'));
}
